var map = {
	"./af/Organization.json": 17969,
	"./af/auth.json": 22609,
	"./af/common.json": 33227,
	"./en/Hangfire.json": 52623,
	"./en/Organization.json": 98435,
	"./en/auth.json": 95324,
	"./en/common.json": 7604,
	"@codehq/aurora-app-core/src/locales/af/Organization.json": 17969,
	"@codehq/aurora-app-core/src/locales/af/auth.json": 22609,
	"@codehq/aurora-app-core/src/locales/af/common.json": 33227,
	"@codehq/aurora-app-core/src/locales/en/Hangfire.json": 52623,
	"@codehq/aurora-app-core/src/locales/en/Organization.json": 98435,
	"@codehq/aurora-app-core/src/locales/en/auth.json": 95324,
	"@codehq/aurora-app-core/src/locales/en/common.json": 7604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15757;